<template>
  <div v-wechat-title="this.$store.state.shop" class="page-group">
    <div class="header">
      <div class="time">
        <span>{{ time }}</span>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="card-content-inner">
          <div class="card-title" @click="handleGoTo('mc-received')">
            <span>
              净销售额
              <font :style="{fontSize:'12px'}">（实收）</font>
            </span>
            <em :style="{color:'#ffa200'}">{{ data.paid_amount }}</em>
          </div>
          <div class="card-item">
            <p>指除去消费退款的实收金额（内含会员卡消费金额，未包含充值金额）</p>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="item-select c44">
          <span>支付方式</span>
          <span>收款笔数</span>
          <span>收款金额</span>
        </div>
        <div class="item-block">
          <ul v-if="data">
            <li v-for="(item,index) in data.paid_amount_payments" :key="index">
              <div class="item-block-cet">
                <div class="item-block-tec">
                  <div class="img">
                    <img :src="item.logo" alt>
                  </div>
                  <div class="name">
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <div class="item-block-tek">
                  <span>{{ item.count }}</span>
                </div>
                <div class="item-block-tek">
                  <span>{{ item.amount }}</span>
                </div>
              </div>
            </li>
          </ul>
          <ul v-if="!data">
            <li>
              <span :style="{'font-size':'13px',color:'#444'}">暂无交易记录</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { FormatDate } from '@/libs/tootl'
import { getTime, getMcChargeJson } from '@/libs/auth.js'
export default {
  data() {
    return {
      time: getTime() || `${new Date().getFullYear()}-${new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()}`,
      data: '',
      listData: []
    }
  },
  created() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      if (getMcChargeJson()) {
        this.data = JSON.parse(getMcChargeJson())
        this.listData = this.data.pay_softwares
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-group{
  overflow-y: scroll
}
.header {
  height: 2.5rem;
  padding: 0 0.25rem;
  line-height: 2.5rem;
  font-size: 15px;
  color: #444;
  .time {
    text-align: center;
  }
}

.card {
  .card-content-inner {
    padding: 0;
  }
  .card-title {
    padding: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    em {
      font-size: 18px;
      font-style: normal;
    }
  }
  .card-item {
    padding: 0.8rem;
    background: rgba(255, 110, 110, 0.1);
    border-radius: 0rem 0rem 0rem 0rem;
    p {
      margin: 0;
      margin-bottom: 0.6rem;
      text-align: left;
      position: relative;
      padding-left: 1.2rem;
      &:after {
        position: absolute;
        left: 0;
        top: 0.2rem;
        content: "";
        clear: both;
        width: 0.67rem;
        height: 0.67rem;
        background: rgba(255, 110, 110, 1);
        border-radius: 50%;
      }
    }
  }
}
.item-select {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 2.25rem;
  line-height: 2.25rem;
  font-size: 14px;
  background-color: #ffffff;
  span {
    width: 33%;
    color: #444444;
    font-size: 15px;
  }
}
.item-block {
  ul {
    margin: 0;
    padding: 0;
    li {
      height: 3.5rem;
      padding: 0 1rem;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eeeeee;
      &:first-child {
        border-top: 2px solid #eeeeee;
      }

      p {
        margin: 0;
        font-size: 15px;
        text-align: left;

        &:last-child {
          color: #757575;
          font-size: 12px;
        }
      }
    }

    .item-block-cet {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: space-between;
    }

    .item-block-tec {
      width: 40%;
      display: flex;
      display: -webkit-flex;
      .name {
        margin-left: 10px;
      }
      .img {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;

        img {
          width: 100%;
        }
      }
    }
    .item-block-tek{
      width: 30%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;

    }
  }
}
</style>
